import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import { Input } from '@mui/material';
import { Badge } from "@mui/material";
import { wait } from '@testing-library/user-event/dist/utils/index.js';
import { set } from 'date-fns';

export default function ExamVerification() {

  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  const tableRef = useRef(null);

  const [disciplineId, setDisciplineChange] = useState(sessionStorage.getItem("discipline_id") ? sessionStorage.getItem("discipline_id") : null);
  const [disciplinetype, setDisciplineTypeChange] = useState(sessionStorage.getItem("discipline_type") ? sessionStorage.getItem("discipline_type") : null);
  const [examid, setExamIdData] = useState(sessionStorage.getItem("eaxm_id") ? sessionStorage.getItem("eaxm_id") : null);


  const [url, setUrl] = useState(null);
  const [registrationcount, setRegistrationcount] = useState({});
  //const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [loading, setlodaing] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]); // Object to track selected rows
  const [totalAmount, setTotalAmount] = useState(0); // Track the total amount
  const [totalDemand, setTotalDemand] = useState(0);
  const [status, setStatus] = useState(false);
  const [activeDate, setActiveDate] = useState(false);
  const [getexamData, setExamData] = useState([]);
  const [courseListData, setCourseListData] = useState([]);
  const [examlink, setExamlink] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusmsg, setStatusmsg] = useState(null);
  const [appar, setAappar] = useState(false);
  const [reload, setreload] = useState(0);

  const { http } = Api();

  let cid = localStorage.getItem("collegeid");

  const isAnyCheckboxSelected = Object.values(selectedRows).some(isSelected => isSelected);


  useEffect(() => {

    http.get(`getActiveEvents`, { params: { event_id: 5 } })
      .then(response => {


        if (response.data[0].status === "active") {

          setStatus(response.data[0].status);
          setActiveDate(response.data[0].end_date);
        }
        else {
          setStatus(false);
        }


      }).catch(error => {
        // console.error("Error in get active events:", error);

      });


  }, [])


  const handlExamChange = (selectedOption) => {

    setExamIdData(selectedOption.value);
    setDisciplineChange(false);
    setDisciplineNameChange(false);
    setDisciplineTypeChange(false);
    setCourseListData([]);


  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(`College/getActiveExams`);
        // console.log("response", response.data);
        setExamData(response.data);
      }
      catch (error) {

        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchExamData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/College/getSchemeWiseCollegeDisciplines`, {
          params: {
            examid: examid,
            college_id: cid
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response.data);

      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, [examid]);


  const handleDisciplineChange = (selectedOption) => {
    setDisciplineChange(selectedOption.did);
    setDisciplineNameChange(selectedOption.value);
    setDisciplineTypeChange(selectedOption.type);
  };


  useEffect(() => {

    const fetchListData = async () => {
      try {
        const response = await http.get(`/College/viewStudentCourseApprovalList`, {
          params: {
            examid: examid,
            discipline_id: disciplineId,
            college_course_type: disciplinetype
          }
        });
        // console.log(response.data.studentlist);
        setCourseListData(response.data.studentlist);
        setlodaing(false);

      }
      catch (error) {
        setlodaing(false);
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    const Registrationcount = async () => {
      try {
        const response = await http.get(`College/getCollegeDisciplineRegistrationcount`, {
          params: {
            examid: examid,
            discipline_id: disciplineId,
            college_course_type: disciplinetype
          }
        });

        setRegistrationcount(response.data[0]);

      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
          setlodaing(false);
        }
      }
    }


    if (examid && disciplineId) {


      setSelectedRows([]);
      setIsSelectAllChecked(false);
      setlodaing(true);

      fetchListData();
      Registrationcount();

    }
  }, [examid, disciplineId, disciplinetype, reload])


  const handleSelectAll = () => {
    const allSelected = !isSelectAllChecked;
    setIsSelectAllChecked(allSelected);

    if (allSelected) {

      const allStudentIds = Object.entries(courseListData)
        .filter(([_, studentDetails]) => studentDetails?.exam_reg_status === 'Approved By DEO' && studentDetails?.malpractice_status === 0)
        .map(([apaarId]) => apaarId);

      setSelectedRows(allStudentIds);

    } else {

      setSelectedRows([]);
    }
  };

  const handleRowSelect = (apaarId) => {

    if (selectedRows.includes(apaarId)) {

      const newselected = selectedRows.filter(id => id !== apaarId)
      setSelectedRows(newselected);

      if (newselected.length === 0) {
        setIsSelectAllChecked(false);
      }

    } else {

      setSelectedRows([...selectedRows, apaarId]);
    }
  };


  useEffect(() => {

    const newTotal = selectedRows.reduce((sum, apaarId) => {
      return sum + parseFloat(courseListData[apaarId].fees);
    }, 0);

    const DemandTotal = selectedRows.reduce((sum, apaarId) => {
      return sum + parseFloat(courseListData[apaarId].Demand_fees);
    }, 0);

    setTotalAmount(newTotal);
    setTotalDemand(DemandTotal);

  }, [selectedRows, courseListData]);


  const handlePayment = (e) => {

    setlodaing(true);

    e.preventDefault();

    http.post(`College/PaymentByPrincipal`, {


      examid: examid,
      apaar_no: selectedRows,
      amount: totalAmount,
      is_demand: 'false'

    }).then(response => {



      setExamlink(response.data.reqParam);
      setUrl(response.data.url)



    }).catch(error => {
      if (error.response?.data?.status_code === 'ERR9') {
        console.log("Invalid Token");
      }
    })

  }

  const handleDemand = (e) => {

    setlodaing(true);

    e.preventDefault();

    http.post(`College/PaymentByPrincipal`, {


      examid: examid,
      apaar_no: selectedRows,
      amount: totalDemand,
      is_demand: 'true'

    }).then(response => {



      setExamlink(response.data.reqParam);
      setUrl(response.data.url)



    }).catch(error => {
      if (error.response?.data?.status_code === 'ERR9') {
        console.log("Invalid Token");
      }
    })

  }

  useEffect(() => {

    if (examlink && url) {
      // Create a form element
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      form.id = 'frmpaymentaction';

      // Create input element
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'epay_req_params';
      input.value = examlink;
      input.id = 'epay_req_params';

      // Append input to form
      form.appendChild(input);

      // Append form to document body
      document.body.appendChild(form);

      // Submit the form
      form.submit();

      // Clean up - remove form after submission
      return () => {
        if (document.getElementById('frmpaymentaction')) {
          document.body.removeChild(form);
        }
        setlodaing(false);

      };
    }
  }, [examlink, url]);


  const student_del = () => {
    setShowModal(false);

    http.post(`College/deleteStudentExamRegistrationRecords`, {

      examid: examid,
      apaar_no: appar

    }).then(response => {
      // console.log(response);
      if (response.data.message.status_code === "MSG3") {

        toast.success("DEO Registration Reverted successfully");
        setreload(1);
        setAappar(false);
      }

    }).catch(error => {
      if (error.response.data.status_code === 'ERR9') {
        console.log("Invalid Token")
        setAappar(false);

      }
    });
  }

  const confirmEdit = (apparid) => {
    setShowModal(true);
    setAappar(apparid);
  };

  const handleClose1 = () => {
    setShowModal(false);
    setAappar(false);
  }

  const handleViewModal = (apaar_id) => {
    const statusmsg = courseListData[apaar_id] ? courseListData[apaar_id] : null;
    setStatusmsg(statusmsg.deo_remarks);
    setShowStatusModal(true);

  };

  const closeModal = () => {
    setShowStatusModal(false);
  };

  //custom  discipline style
  const disciplineStyles = {

    option: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();  // SF / AIDED

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      if (state.isSelected) {
        return {
          ...provided,
          backgroundColor: "#ebebeb",
          color: color,   // KEEP suffix color even when selected
          fontWeight: "600",
        };
      }

      return {
        ...provided,
        color: color,
      };
    },

    // THIS makes the selected item in the select box colored
    singleValue: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      return {
        ...provided,
        color: color,
        fontWeight: "600",
      };
    },
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        ) : (


          <div className="my-page">

            <div className="container-fluid">

              <div className={`modal fade show ${showModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="modal-toggle-wrapper">
                        <h4 className="text-center pb-2">Are you sure you want to Revert?</h4>
                        <div className="d-flex justify-content-center mt-3">
                          <button className="btn btn-danger mx-2" onClick={student_del}>Revert</button>
                          <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleClose1()}>Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Student Exam Registration Approval</h5>
                          <div className="buttons-container">




                          </div>
                        </div>

                      </div>
                      <div className="card-body">



                        <div className="card-body pdg">
                          <div className="table-responsive">

                            <div className="form theme-form">
                              <div className="card-body custom-input">


                                <div className="row">
                                  <div className="col-md-6">
                                    <label>Exam<span className="errorclr">*</span></label>

                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="exam_id"
                                      name="exam_id"
                                      className="basic-select"
                                      classNamePrefix="select"
                                      options={getexamData.map(exam => ({
                                        value: exam.examid,
                                        label: exam.examtitle
                                      }))}
                                      onChange={handlExamChange}
                                      placeholder="Select an exam..."

                                      value={getexamData
                                        .filter(exam => exam.examid.toString() == examid ? examid.toString() : '')
                                        .map(exam => ({
                                          value: exam.examid,
                                          label: exam.examtitle
                                        }))[0]}
                                    />
                                  </div>


                                  <div className="col-md-6">
                                    <label>Discipline<span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="discipline_id"
                                      name="discipline_id"
                                      className="form"
                                      styles={disciplineStyles}
                                      onChange={handleDisciplineChange}
                                      options={Array.isArray(disciplinedata) && disciplinedata.length > 0
                                        ? disciplinedata
                                          .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                          .map(discipline => ({
                                            did: discipline.discipline_id,
                                            value: discipline.discipline_name,
                                            label: discipline.discipline_name,
                                            type: discipline.college_course_type
                                          }))
                                        : [{ value: '0', label: 'No data found' }]
                                      }
                                      value={disciplinedata && Array.isArray(disciplinedata)
                                        ? disciplinedata
                                          .filter(discipline =>
                                            discipline.discipline_id == disciplineId &&
                                            discipline.college_course_type == disciplinetype
                                          )
                                          .map(discipline => ({

                                            did: discipline.discipline_id,
                                            value: discipline.discipline_name,
                                            label: discipline.discipline_name,
                                            type: discipline.college_course_type

                                          }))
                                        : null}
                                    />

                                  </div>


                                </div>


                                {status != 'active' && (
                                  <div className="txt-aln">
                                    <p style={{ color: 'red', marginBottom: '10px' }}>Exam registration approval time is closed.No actions can be performed.</p>

                                  </div>
                                )}


                                <div class="table-container">
                                  <table className="table-striped table-bordered ex-table" ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="col-cnt-tab-bg-clr">
                                        <th scope="col" width="10%">Sl No.</th>
                                        <th scope="col" width="">Total Students</th>
                                        <th scope="col" width="">Registered Students</th>
                                        <th scope="col" width="">Approved by DEO</th>
                                        <th scope="col" width="">Payment done by Principal</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <tr>
                                        <td>{registrationcount.totalStudents ? 1 : "--"}</td>
                                        <td>{registrationcount.totalStudents ? registrationcount.totalStudents : "0"}</td>
                                        <td>{registrationcount.RegCnt ? registrationcount.RegCnt : "0"}</td>
                                        <td>{registrationcount.AprCnt ? registrationcount.AprCnt : "0"}</td>
                                        <td>{registrationcount.AprPrincipal ? registrationcount.AprPrincipal : "0"}</td>

                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="table-container">
                                  <div className="row m-t-20">

                                    {status === "active" && Object.keys(courseListData).length > 0 && (
                                      <div className="col-md-6">
                                        <div className="m-t-10">
                                          <input
                                            id="select-all"
                                            type="checkbox"
                                            onChange={handleSelectAll}
                                            checked={isSelectAllChecked}
                                          />
                                          <label for="select-all">&nbsp;Select All</label>
                                        </div>
                                      </div>
                                    )
                                    }

                                    <div className="col-md-6 d-flex justify-content-end">
                                      {isAnyCheckboxSelected && status === "active" && (
                                        <div className="d-flex align-items-center gap-3">
                                          <div className="d-flex align-items-center gap-4 px-3 py-2 bg-light rounded">
                                            <div>
                                              <small className="text-muted d-block">Total Demand</small>
                                              <strong className="text-dark">₹{totalDemand}</strong>
                                            </div>
                                            <div className="vr"></div>
                                            <div>
                                              <small className="text-muted d-block">Payable Amount</small>
                                              <strong className="text-primary">₹{totalAmount}</strong>
                                            </div>
                                          </div>
                                          <form onSubmit={handleDemand}>
                                            <button className="btn btn-primary" type="submit">
                                              Pay ₹{totalDemand}
                                            </button>
                                          </form>
                                          <form onSubmit={handlePayment}>
                                            <button className="btn btn-primary" type="submit">
                                              Pay ₹{totalAmount}
                                            </button>
                                          </form>
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <table className=" dataTable   ex-v-table " ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="bg-primary">
                                        <th scope="col" width="4%">

                                          {status === "active" && Object.keys(courseListData).length > 0 && (

                                            <input id="select-all" type="checkbox"
                                              onChange={handleSelectAll}
                                              checked={isSelectAllChecked} />
                                          )}

                                        </th>
                                        {/* <th scope="col" width="10%">Sl No</th> */}
                                        <th scope="col" width="9%">APAAR / PRN</th>
                                        <th scope="col" width="10%">Name</th>

                                        <th scope="col" width="30%">Courses</th>
                                        <th scope="col" width="7%">Demand</th>
                                        <th scope="col" width="7%">Amount</th>

                                        <th scope="col" width="7%">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.keys(courseListData).length > 0 ? (
                                        Object.keys(courseListData).map((apaar_id) => {
                                          const student = courseListData[apaar_id];

                                          return (
                                            <tr key={apaar_id} style={student.exam_reg_status === "Not Registered" ? { backgroundColor: '#FEF6F7' } : {}}>
                                              <td scope="row" className="text-center">
                                                {student.exam_reg_status === 'Approved By DEO' && status === "active" && student.malpractice_status === 0 && (
                                                  <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(apaar_id)}
                                                    onChange={() => handleRowSelect(apaar_id)}
                                                  />
                                                )}
                                              </td>
                                              <td data-label="APAAR Id">
                                                {student.exam_reg_status === 'Approved By Principal' ? (
                                                  <div className="txt-aln m-b-10">
                                                    <span class="badge badge-success text-white rounded-pill">
                                                      <i class="bi bi-check2-all" aria-hidden="true" style={{ cursor: "pointer", fontSize: "1.5em" }} ></i>
                                                    </span>.
                                                  </div>
                                                ) : student.exam_reg_status === 'Approved By DEO' ? (
                                                  <div className="txt-aln m-b-10">
                                                    <span class="badge badge-success text-white rounded-pill">
                                                      <i class="fa fa-clipboard-check" aria-hidden="true" style={{ cursor: "pointer", fontSize: "1.5em" }} ></i>
                                                    </span>
                                                  </div>
                                                ) : student.exam_reg_status === 'Entry Level' && (
                                                  <div className="txt-aln m-b-10">
                                                    <span class="badge badge-warning text-white rounded-pill">
                                                      <i className="fa  fa-clipboard" style={{ cursor: "pointer", fontSize: "1.5em" }}></i>
                                                    </span>
                                                  </div>
                                                )}
                                                <div className='txt-aln'>{apaar_id} / {student.PRN}</div>
                                              </td>

                                              <td data-label="Name" className="text-center" >{student.studentname}</td>

                                              <td>
                                                <div className="treeview">
                                                  <ul>
                                                    {student.courses.map((course, index) => (

                                                      <li key={index} className="ex-v-tab-li-fnt"><b>{course.paper_identifier}</b> - {course.course_name}
                                                        <span class={`badge rounded-pill ${course.paper_status === "registered" ? "bg-success" : "bg-danger"}`} style={{ marginLeft: '1em' }}>{course.paper_status}</span>
                                                      </li>

                                                    ))}

                                                  </ul>
                                                </div>
                                              </td>
                                              <td className="text-center" data-label="Demand_fees">₹ {student.Demand_fees}</td>
                                              <td className="text-center" data-label="fees">₹ {student.fees}</td>
                                              <td className="text-center" data-label="Action" >
                                                {(() => {
                                                  if (student.malpractice_status === 1) {

                                                    return <span className='badge rounded-pill bg-danger'>Malpractice</span>;
                                                  }
                                                  else {


                                                    switch (student.exam_reg_status) {
                                                      case 'Approved By DEO':
                                                        if (status === "active") {
                                                          return (
                                                            <>
                                                              <i className="icon-comment-alt" style={{ cursor: "pointer", fontSize: "1.5em" }} aria-hidden="true" aria-label="View Remark" onClick={() => handleViewModal(apaar_id)}></i>&nbsp;&nbsp;

                                                              <i className="fa fa-undo" style={{ cursor: "pointer", fontSize: "1.5em", color: "red" }} aria-hidden="true" aria-label="Revert DEO Registration" onClick={() => confirmEdit(apaar_id)}></i>
                                                            </>
                                                          );
                                                        } else {
                                                          return <div className="txt-aln">Deo Approved</div>;
                                                        }
                                                      case 'Not Registered':
                                                        return <div className="txt-aln">DEO Verification Pending</div>;
                                                      case 'Approved By Principal':
                                                        return <span>Fee Paid - Forwarded to University</span>;
                                                      default:
                                                        return <span> DEO Forwarding Pending</span>;
                                                    }
                                                  }
                                                })()}
                                              </td>

                                            </tr>
                                          );

                                        })
                                      ) : (
                                        <tr>
                                          <td colSpan="6" className="text-center">No data found</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>


                                  {showStatusModal && (
                                    <div className="modal fade show d-block" style={{ backdropFilter: 'blur(2px)' }}>
                                      <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="modal-title">Remarks</h5>
                                            <div className="close" onClick={closeModal} style={{ cursor: "pointer", fontSize: "1.5em" }}>&times;</div>
                                          </div>
                                          <div className="modal-body">
                                            {statusmsg ? (
                                              <p>{statusmsg}</p>) : (
                                              <p>no remarks</p>
                                            )}
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  )}


                                </div>

                              </div>


                            </div>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


      </Template>
    </>
  );
}
